__turbopack_context__.v({
  "moderationContent": "ModerationRulesModal-module-scss-module__kshc0a__moderationContent",
  "moderationModal": "ModerationRulesModal-module-scss-module__kshc0a__moderationModal",
});
